var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNobgicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.33333C9.84079 7.33333 11.3332 5.84095 11.3332 4C11.3332 2.15905 9.84079 0.666667 7.99984 0.666667C6.15889 0.666667 4.6665 2.15905 4.6665 4C4.6665 5.84095 6.15889 7.33333 7.99984 7.33333Z",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.3333V13.5C14 11.5747 11.3 10 8 10C4.7 10 2 11.5747 2 13.5V15.3333",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNobgicon);
export default __webpack_public_path__ + "static/media/user-nobg.icon.7b2c7b47080a5687b67280d469017b7c.svg";
export { ForwardRef as ReactComponent };